import { onBeforeUnmount, onMounted, unref } from 'vue';

export const useShopManagementShortcuts = ({
  openCommandPalette,
  showSidebarBackdrop,
  sidebarOpen,
  enabled = true,
}) => {
  const handleKeydown = (event) => {
    const key = String(event.key || '').toLowerCase();

    if (unref(enabled) && (event.metaKey || event.ctrlKey) && key === 'k') {
      event.preventDefault();
      openCommandPalette();
      return;
    }

    if (event.key === 'Escape' && showSidebarBackdrop.value) {
      sidebarOpen.value = false;
    }
  };

  onMounted(() => document.addEventListener('keydown', handleKeydown));
  onBeforeUnmount(() => document.removeEventListener('keydown', handleKeydown));

  return {
    handleKeydown,
  };
};
